import React, { Component, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { TimeUntilSubmissionEnd } from './TimeUntilSubmissionEnd';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import AuthenticationContext from './context/AuthenticationContext';
import { PaymentLinkNoticePopup } from './PaymentLinkNoticePopup';
import { UserChat } from './chat/UserChat';

export const Layout = (props: any) => {

    const authCtx = useContext(AuthenticationContext);

    return <div>
        <ToastContainer position='top-right' />
        <PaymentLinkNoticePopup />
        <NavMenu />
        <TimeUntilSubmissionEnd />
        <Container tag="main">
            <Row>
                <Col>
                    <div className="disclaimer-box col-sm-12">
                        <p className="disclaimer">The AIMG Program 2027 Cycle - 2nd Iteration online application will tentatively open Jul 24, 2026. Profiles can be created or edited at that time. <strong>All supporting documents are due by Sept 1, 2026.</strong> Please refer to our <a href="https://www.aimg.ca/" target="_blank">website</a> for requirements and timelines.</p>
                    </div>
                    {props.children}
                </Col>
            </Row>
        </Container>
        {authCtx.currentUser?.isAdmin == false && (authCtx.currentUser?.id || '').length > 0 &&  <UserChat />}
    </div>

}